import React, { useState } from 'react';
export function StickyBar() {
  const [visible, setVisible] = useState(true);
  if (!visible) return null;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-[#0d4a45] border-b border-[#c9a84c]/30 py-2.5 px-4" data-id="element-361">
      <div className="max-w-5xl mx-auto flex items-center justify-between gap-3" data-id="element-362">
        <p className="text-[#e8c97a] text-sm font-dm font-medium text-center flex-1" data-id="element-363">
          ⚡ <span className="font-bold" data-id="element-364">OFERTA ESPECIAL:</span> Solo $6.36 hoy
          — Precio sube a $97 esta semana
        </p>
        <div className="flex items-center gap-3 shrink-0" data-id="element-365">
          <a href="#oferta" className="bg-[#c9a84c] hover:bg-[#e8c97a] text-[#0d4a45] text-xs font-bold font-dm px-3 py-1.5 rounded-full transition-colors whitespace-nowrap" data-id="element-366">
            Quiero mi guía →
          </a>
          <button onClick={() => setVisible(false)} className="text-white/50 hover:text-white text-lg leading-none transition-colors" aria-label="Cerrar" data-id="element-367">
            ×
          </button>
        </div>
      </div>
    </div>;
}